module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/plus_icon-13c4043723fbdded9f05aa904f159948.svg";